import React, { useState } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import GroupsTab from './ProjectDocuments/GroupsTab';
import FoldersTab from './ProjectDocuments/FoldersTab';

const ProjectDocuments = () => {

  const [collapse, setCollapse] = useState(true);
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <div className='settings-tenant-main-container'>
      <div
        className='settings-main-tenant-text'
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          cursor: 'pointer',
        }}
        onClick={() => setCollapse(!collapse)}
      >
        <h3>Project Documents</h3>
        <i
          className={collapse ? 'fa fa-chevron-down' : 'fa fa-chevron-up'}
          aria-hidden='true'
        />
      </div>
      <hr />
      <div
        className={
          collapse ? 'administration-hidden' : 'administration-visible'
        }
      >
        {/* Tabs using react-tabs */}
        <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
          <TabList>
            <Tab>Groups</Tab>
            <Tab>Folders</Tab>
          </TabList>

          <TabPanel>
            <GroupsTab />
          </TabPanel>

          <TabPanel>
            <FoldersTab />
          </TabPanel>
        </Tabs>
      </div>

      <br />
    </div>
  );
};

export default ProjectDocuments;
